var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504703 5.16217L1.89337 6.55084C2.0809 6.73831 2.33521 6.84362 2.60037 6.84362C2.86553 6.84362 3.11984 6.73831 3.30737 6.55084L7.59604 2.26217C7.65676 2.1993 7.69035 2.1151 7.6896 2.0277C7.68884 1.9403 7.65378 1.8567 7.59198 1.7949C7.53017 1.73309 7.44657 1.69804 7.35917 1.69728C7.27177 1.69652 7.18757 1.73012 7.1247 1.79084L2.83604 6.0795C2.77353 6.14199 2.68876 6.1771 2.60037 6.1771C2.51198 6.1771 2.42721 6.14199 2.3647 6.0795L0.976037 4.69084C0.913169 4.63012 0.828969 4.59652 0.74157 4.59728C0.654171 4.59804 0.570567 4.63309 0.508764 4.6949C0.446961 4.7567 0.411905 4.8403 0.411145 4.9277C0.410386 5.0151 0.443984 5.0993 0.504703 5.16217Z",
    fill: "#68B859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.18dbbc9b2216f80e00e81b6077da4df1.svg";
export { ForwardRef as ReactComponent };